import { graphql } from 'src/graphql';

import { MessagesFields } from 'src/fragments/messagesFields.fragment';

export const CreateMessage = graphql(
  `
    mutation createMessage($message: MessagesInput!) {
      createMessage(message: $message) {
        ...MessagesFields
      }
    }
  `,
  [MessagesFields],
);
